import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Button, Form, Input, QRCode, Skeleton, Modal, Tag } from "antd";
import "./DetailProduct.css";
import { useMediaQuery } from "react-responsive";
import { LanguageContext } from "../../../context/Language.contex";
import { formatDate } from "../../../utils/DateTime";

export const ScanVisitor = () => {
  const [visitor, setVisitor] = useState({});
  const [fetchDataLoading, setFetchDataLoading] = useState(false);
  const [value, setValue] = useState();
  const { error } = Modal;
  const { language } = useContext(LanguageContext);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  useEffect(() => {
    console.log(value);
    setVisitor(visitor);
    if (value) {
    }
  }, [visitor]);

  const onFinish = (values) => {
    setFetchDataLoading(true);
    axios
      .get(
        `https://cmi-general-platform-be.vercel.app/visitor/${values.search}`
      )
      .then((res) => {
        const { data } = res.data;
        console.log(data);

        if (data.length <= 0) {
          error({
            title: `Visitor not found!`,
            content: "Please input the correct visitor code!",
          });
        }
        setFetchDataLoading(false);
        setVisitor(data);
      })
      .catch((err) => {
        console.log(err);
        error({
          title: "Visitor not found!",
          content: "Please try again!",
        });
        setFetchDataLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  function FormInput() {
    return (
      <Form
        layout="vertical"
        autoComplete="off"
        style={{ textAlign: "center" }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label={"Code " + language[12]}
          name="search"
          rules={[
            {
              required: true,
              message: "Please input your code!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={fetchDataLoading}>
            {language[23]}
          </Button>
        </Form.Item>
      </Form>
    );
  }

  return (
    <>
      <div
        className="scan-visitor-container"
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 2fr",
          gap: "20px",
          padding: "20px",
          background: "#fff",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Bagian Barcode */}
        <div
          className="barcode-section"
          style={{
            display: "flex", // Menggunakan Flexbox
            flexDirection: "column", // Menyusun elemen secara vertikal
            alignItems: "center", // Menengahkan elemen secara horizontal
            justifyContent: "center", // Menengahkan elemen secara vertikal (opsional jika hanya ingin center horizontal)
            padding: "20px",
            border: "1px solid #f0f0f0",
            borderRadius: "8px",
            textAlign: "center", // Memastikan teks tetap rata tengah
          }}
        >
          {/* Judul Barcode */}
          <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>Barcode</h2>

          {/* QR Code */}
          <div
            style={{
              display: "flex",
              alignItems: "center", // Memastikan QR Code berada di tengah
              justifyContent: "center", // Memastikan QR Code berada di tengah
            }}
          >
            <QRCode
              value={visitor?.code || ""}
              size={130} // Ukuran tetap untuk QR Code
              style={{
                border: "2px solid #2C74B3", // Border untuk QR Code
                padding: "10px", // Padding untuk memberikan ruang di dalam border
                borderRadius: "8px", // Rounded corner untuk tampilan lebih modern
              }}
            />
          </div>

          {/* Kode Pengunjung */}
          <span
            style={{
              display: "block",
              marginTop: "10px",
              fontSize: "14px",
            }}
          >
            {visitor?.code}
          </span>

          {/* Form Input */}
          <div
            style={{
              marginTop: "20px",
            }}
          >
            <FormInput />
          </div>
        </div>

        {/* Bagian Biodata Visitor */}
        <div
          className="biodata-section"
          style={{
            textAlign: "left",
            padding: "20px",
            border: "1px solid #f0f0f0",
            borderRadius: "8px",
          }}
        >
          <h1 style={{ fontSize: "24px", marginBottom: "20px" }}>
            {language[29]}
          </h1>
          <h1 style={{ fontSize: "20px", marginBottom: "20px" }}>
            {visitor?.name}
          </h1>

          {visitor !== null ? (
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "left",
              }}
            >
              <tbody>
                <tr>
                  <th style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    {language[8]}:
                  </th>
                  <td>{visitor?.detail_institution}</td>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    {language[6]}:
                  </th>
                  <td>{visitor?.detail_address}</td>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    {language[7]}:
                  </th>
                  <td>{visitor?.detail_phone}</td>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    {language[9]}:
                  </th>
                  <td>{visitor?.detail_description}</td>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    {language[10]}:
                  </th>
                  <td>{visitor?.detail_appointment}</td>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    Register:
                  </th>
                  <td>
                    {visitor?.detail_created_at == null
                      ? "-"
                      : formatDate(visitor?.detail_created_at)}
                  </td>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    Expired:
                  </th>
                  <td>
                    {visitor?.detail_expired_at == null
                      ? "-"
                      : formatDate(visitor?.detail_expired_at)}
                  </td>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    {language[25]}:
                  </th>
                  <td>
                    <Tag
                      color={
                        visitor?.status_code === "VERIFIED"
                          ? "success"
                          : "error"
                      }
                      style={{ textTransform: "uppercase" }}
                    >
                      {visitor?.status_code === "VERIFIED"
                        ? "APPROVE"
                        : visitor?.status_code === "UNVERIFIED"
                        ? "UNAPPROVE"
                        : "WAITING"}
                    </Tag>
                  </td>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    Condition:
                  </th>
                  <td>
                    <Tag
                      color={
                        visitor?.active == "IN"
                          ? "success"
                          : visitor?.active == "OUT"
                          ? "error"
                          : "warning"
                      }
                    >
                      {visitor?.active == "IN"
                        ? "IN"
                        : visitor?.active == "OUT"
                        ? "FINISH"
                        : "WAITING ROOM"}
                    </Tag>
                  </td>
                </tr>

                <tr>
                  <th style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    {language[15]}:
                  </th>
                  <td>{visitor?.approver_username ?? `- ${language[30]} -`}</td>
                </tr>

                <tr>
                  <th style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    {language[26]} IN :
                  </th>
                  <td
                    style={
                      visitor?.verifikator_in_name
                        ? null
                        : {
                            color: "red",
                            fontSize: "12px",
                            animation: "blink 1s infinite",
                          }
                    }
                  >
                    {visitor?.verifikator_in_name ?? `- ${language[31]} -`}
                  </td>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    {language[26]} OUT :
                  </th>
                  <td
                    style={
                      visitor?.verifikator_out_name
                        ? null
                        : {
                            color: "red",
                            fontSize: "12px",
                            animation: "blink 1s infinite",
                          }
                    }
                  >
                    {visitor?.verifikator_out_name ?? `- ${language[31]} -`}
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <div
              style={{
                textAlign: "center",
                marginTop: "20px",
              }}
            >
              <Skeleton active paragraph={{ rows: 4 }} />
              <Button type="primary" disabled style={{ marginTop: "10px" }}>
                Loading..
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
